var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])
}]

export { render, staticRenderFns }